import GridList from "../../../../../components/ui/grid"
import KnowCredCard from "../../../knowCred/knowCredCard"
import { useDispatch, useSelector } from "react-redux"
import ListPage from "../../../../../components/v2/layout/listPage/listPage"
import {
  clearTeacherKnowmapKnowcreds,
  getTeacherKnowmapKnowcreds,
} from "../../../../../library/store/actions/creators/knowmapCreators"
import { createSelector } from "@reduxjs/toolkit"
import { Redirect } from "react-router-dom"
import { KNOWMAP_KNOWCRED_VALID } from "../../../../../library/constants/routes"

const selectPageData = createSelector(
  (state) => ({
    list: state.knowmap.teacherKnowcred,
    endReached: state.knowmap.teacherKnowcredEndReached,
  }),
  (state) => state.auth.userData.role,
  (teacherKnowcred, userRole) => ({ teacherKnowcred, userRole })
)

const KnowmapTeacherKnowcred = () => {
  const dispatch = useDispatch()

  const { teacherKnowcred, userRole } = useSelector(selectPageData)

  if (userRole === 1) return <Redirect to={KNOWMAP_KNOWCRED_VALID} />

  return (
    <ListPage
      title={"Creds"}
      noResultsLabel={"You haven't created any Creds yet"}
      list={teacherKnowcred.list}
      listEndReached={teacherKnowcred.endReached}
      ListContainer={GridList}
      getList={async ({ name: title, offset }) => {
        await dispatch(getTeacherKnowmapKnowcreds({ title, offset }))
      }}
      clearList={() => dispatch(clearTeacherKnowmapKnowcreds())}
      getListItemComponent={({ item }) => (
        <KnowCredCard knowCred={item} key={item.id} />
      )}
    />
  )
}

export default KnowmapTeacherKnowcred
